import { ReplaceEmbedSources } from "@talladega/helpers";
import { EmbeddedVideoPlayerLayout } from "@talladega/types";
import classNames from "classnames";

export const EmbeddedVideoPlayer = ({
  contentVideo,
  roundEdges = true,
  fullWidth = true,
}: EmbeddedVideoPlayerLayout) => {
  if (!contentVideo) {
    return null;
  }
  const embedSource = ReplaceEmbedSources(contentVideo);

  return (
    <div id="cms-embedded-video-player">
      <div
        className={classNames({
          "aspect-h-9 aspect-w-16": fullWidth,
          "aspect-w-16 h-96": !fullWidth,
        })}
      >
        <iframe
          className={classNames({ "overflow:hidden rounded-lg": roundEdges })}
          src={embedSource}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          title="video"
        />{" "}
      </div>
    </div>
  );
};

export default {};
